// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8m1kF","question":"styles_question__3icM4","description":"styles_description__2yDem"};